/**
 * CreateRSP.js — Formulaire de configuration du phidget RSP
 * Design System SEIZO : #002335 | #00B0FF | #F4F7F9 | Sofia Pro / Nunito
 */
import React, { useState } from 'react';
import { useStores } from '../../stores/Context';
import { v4 as uuidv4 } from 'uuid';
import FormConfiguration, {
    BoutonSupprimerWidget,
    TitreConfigurerPhidget,
    WidgetTitre,
} from './FormConfiguration';
import BtnPrimary from '../../boiteAOutils/BtnPrimary';
import styles from './CreatePlanningActions.module.scss'; // réutilise les styles du PA

const CreateRSP = () => {
    const [nom, setNom] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const { widgetStore, uiStore } = useStores();

    const peutCreer = nom.trim() !== '' && !submitting;

    const handleCreer = () => {
        if (!peutCreer) return;
        setSubmitting(true);
        widgetStore.addWidgetAvailable({
            idWidget: uuidv4(),
            typeWidget: 'WidgetRSP',
            nomWidget: nom.trim(),
            disConfig: '',
            config: {},
        });
        uiStore.backNivOAfterAddPhidget();
    };

    return (
        <>
            <div>
                <TitreConfigurerPhidget />
                <WidgetTitre titre="Résolution de Problèmes" />
            </div>

            <div className={styles.listeChampsFormulaire}>
                <div className={styles.form_add_widget}>
                    <label htmlFor="rsp-nom">Nom du module</label>
                    <input
                        id="rsp-nom"
                        type="text"
                        className={styles.input_add_widget}
                        value={nom}
                        onChange={e => setNom(e.target.value)}
                        placeholder="Ex : Résolution qualité atelier A"
                        onKeyDown={e => e.key === 'Enter' && handleCreer()}
                        autoFocus
                    />
                </div>

                <p style={{ fontSize: '12px', color: '#A8B0B3', lineHeight: 1.5, margin: 0 }}>
                    Ce phidget vous permet de gérer vos problèmes en 5 étapes : définir (QQOQCCP), analyser les causes (6M), proposer des solutions, prioriser avec une matrice de décision, puis valider et clôturer.
                </p>
            </div>

            <div style={{ marginTop: 'auto', paddingTop: 16 }}>
                <BtnPrimary
                    label={submitting ? 'Création…' : 'Créer le phidget'}
                    disabled={!peutCreer}
                    onClick={handleCreer}
                />
            </div>
        </>
    );
};

export default CreateRSP;
